<aside class="sidebar" [class.sidebar--open]="isOpen()">
  <div class="sidebar__header">
    <div class="sidebar__brand">
      <span class="sidebar__brand-name">VASELINE</span>
      <span class="sidebar__brand-subtitle">Gluta-Hya Admin</span>
    </div>
    <button
      type="button"
      class="sidebar__close"
      (click)="onNavClick()"
      aria-label="Close navigation menu"
    >
      <app-icon name="x" [size]="20" />
    </button>
  </div>

  <nav class="sidebar__nav">
    @for (item of navItems; track item.route) {
      @if (item.enabled) {
        <a
          class="sidebar__nav-item"
          [routerLink]="[item.route]"
          routerLinkActive="sidebar__nav-item--active"
          [routerLinkActiveOptions]="{ exact: true }"
          (click)="onNavClick()"
        >
          <app-icon [name]="item.icon" [size]="18" />
          <span>{{ item.label }}</span>
        </a>
      } @else {
        <span class="sidebar__nav-item sidebar__nav-item--disabled">
          <app-icon [name]="item.icon" [size]="18" />
          <span>{{ item.label }}</span>
        </span>
      }
    }
  </nav>

  <div class="sidebar__footer">
    <div class="sidebar__user">
      <span class="sidebar__avatar">{{ initials() }}</span>
      <span class="sidebar__user-name">{{ fullName() || 'Administrator' }}</span>
    </div>
    <button type="button" class="sidebar__action" (click)="onSignOut()">
      <app-icon name="log-out" [size]="16" />
      <span>Log Out</span>
    </button>
  </div>
</aside>
